import React from 'react';
export const SpaceBox = props => <div style={{ width:props.w || '7px', height: props.h || '1px' }}></div>